import { useTheme } from '../ThemeContext';

export default function JapanFooter() {
  const { theme, setTheme } = useTheme();

  return (
    <footer className="footer">
      <p>© 2026 ZS Animal Shelter. All rights reserved.</p>
      <div className="footer-links">
        <a href="#">Privacy Policy</a>
        <a href="#">Terms of Use</a>
        <a href="#">Contact</a>
        <a href="#">Link Exchange</a>
        <a href="#">BBS</a>
      </div>
      <div className="theme-switcher" style={{ marginTop: '10px', textAlign: 'center' }}>
        <label style={{ fontSize: '9px', marginRight: '8px' }}>Theme:</label>
        <select
          value={theme}
          onChange={(e) => setTheme(e.target.value as 'japan' | 'default')}
          style={{ fontSize: '9px', padding: '2px' }}
        >
          <option value="japan">Japan Theme</option>
          <option value="default">Default Theme</option>
        </select>
      </div>
      <p style={{ marginTop: '5px', fontSize: '9px' }}>
        ♪ 本日も動物たちのためにありがとうございます ♪
      </p>
    </footer>
  );
}
